import { MixpanelAnalytics } from '@/integrations/analytics';
import { getEnvVar } from '@/shared/utils/envVarConfig';

import { ConsoleAnalytics } from './ConsoleAnalytics';

export * from './Analytics';
export * from './mapOnboardingToAnalytics';

export const analytics =
  getEnvVar('VITE_MIXPANEL_ENABLED') === 'true'
    ? new MixpanelAnalytics()
    : new ConsoleAnalytics();
